export const setTitleHeader = value => {
  return {
    type: "SET_TITLE_HEADER",
    value: value
  };
};
